<template>
  <div class="center contactpage px-3">
    <div
      class=""
      style="padding-top: 15vh;"
    >
      <h1
        style="font-weight: 900;"
        class="mb-3"
      >Book a Demo</h1>
      <!-- <hr> -->
      <h3>Let's talk about how we can bring your platform to life online!</h3>
      <p style="font-size: 1.1rem;">Please fill in the info below and a member of our team will be in touch shortly to set up a call to walk you through our system.</p>
      <div
        class="center mt-4"
        style="max-width: 600px;"
      >
        <input
          type="text"
          class="form-control mb-2"
          placeholder="Name*"
          v-model="name"
        >
        <input
          type="text"
          class="form-control mb-2"
          placeholder="Email*"
          v-model="email"
        >
        <input
          type="text"
          class="form-control mb-2"
          placeholder="Phone Number"
          v-model="phone"
        >
        <input
          type="text"
          class="form-control mb-2"
          placeholder="Website"
          v-model="website"
        >
        <textarea
          class="form-control"
          rows="4"
          placeholder="Any notes? Anything you would like us to know about your business and goals? Any times and days that work well for you for a conversation?"
          v-model="message"
        ></textarea>
      </div>
      <div>
        <button
          class="mylisting-button dark-button"
          @click="submitContact()"
        >Submit</button>
      </div>
      <div
        v-if="justSubmitted"
        class="mt-4"
      >
        <h4>Thank you, we'll be in touch soon!</h4>
      </div>
      <p
        class="mt-5"
        style="font-size: 1.1rem; padding-bottom: 15vh;"
      >1.855.775.4473 | info@enginehire.io</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      website: "",
      message: "",
      justSubmitted: false,
    };
  },
  created() {
    // Scroll the window to top on load
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },
  methods: {
    submitContact() {
      this.$store.dispatch("sendEmail", {
        subject: "Enginehireio Contact Form Submission",
        message:
          "New contact form submission!\n\n" +
          "Name: " +
          this.name +
          "\nEmail: " +
          this.email +
          "\nPhone: " +
          this.phone +
          "\nWebsite: " +
          this.website +
          "\nMessage: " +
          this.message,
        from: "contactform@enginehire.io",
        email: "aakash@enginehire.ca",
        reply: "aakash@enginehire.ca",
        userID: 4,
      });

      this.justSubmitted = true;
    },
  },
};
</script>

<style>
.contactpage {
  /* background-color: #fcbf67; */
  /* height: 100vh; */
  margin-top: auto;
  margin-bottom: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue